import { z } from 'zod'
import { validatePassword } from '~/@lib/utils/password.utils'

export function newPasswordValidationSchema(newPasswordMinOneError: string) {
  return z
    .string()
    .min(1, newPasswordMinOneError)
    .max(50, 'Heslo môže mať max. 50 znakov')
    .refine((value) => {
      const error = validatePassword(value)
      return error === null
    }, 'Najmenej 8 znakov, veľké a malé písmená a číslo.')
}

export function confirmPasswordValidationSchema(
  confirmPasswordMinOneError: string
) {
  return z.string().min(1, confirmPasswordMinOneError).max(50)
}

export const changePasswordSchema = z
  .object({
    oldPassword: z
      .string()
      .min(1, 'Zadajte svoje súčasné heslo')
      .max(50, 'Neplatntý formát súčasného hesla'),
    newPassword: newPasswordValidationSchema('Zadajte nové heslo'),
    confirmPassword: confirmPasswordValidationSchema('Potvrďte nové heslo'),
  })
  .refine(
    (data) => {
      const error = validatePassword(data.confirmPassword, data.newPassword)
      return error === null
    },
    {
      message: 'Heslá sa nezhodujú',
      path: ['confirmPassword'],
    }
  )

export type ChangePasswordSchema = z.infer<typeof changePasswordSchema>
